import { checkFileTotalSize, createActivityBody } from 'utils';
import { Grid, Typography } from '@material-ui/core';
import { ServiceApi } from 'services';
import { toastMessages } from 'config/constants';
import { useCompany } from 'contexts/CompanyContext';
import { useHistory } from 'react-router-dom';
import ActivityForm from 'components/ActivityForm';
import MaiaLogo from 'components/MaiaLogo';
import RegisterLayout from 'pages/RegisterLayout';
import routes from 'config/routes';
import sideImage from '_assets/register/Activitie.svg';
import toast from 'react-hot-toast';
import useStyles from './styles';

const INITIAL_ACTIVITY = {
  courseType: 'private',
  description: '',
  duration: '60',
  employeesAndAddresses: [],
  identifier: '',
  level: 'beginner',
  maxAge: '0',
  minAge: '0',
  priceHighSeason: '0',
  priceLowSeason: '0',
  productName: '',
  publish: false,
  slots: '1',
  status: 'enabled',
};

const RegisterActivities = () => {
  const classes = useStyles();
  const history = useHistory();

  const { currentCompany } = useCompany();

  const handleCreateActivity = async (values, picture) => {
    let formData = createActivityBody(values);
    if (picture.file) {
      if (!checkFileTotalSize([picture.file])) {
        toast.error(toastMessages.error.UPLOAD_PICTURE_SIZE_LIMIT);
        return { pictureSizeError: true };
      }
      formData.append('serviceImage', picture.file);
    }

    try {
      await ServiceApi.createCompanyService(currentCompany.id, formData);
      toast.success(toastMessages.success.CREATE_ACTIVITY);
      return { success: true };
    } catch (error) {
      toast.error(toastMessages.error.CREATE_ACTIVITY);
      return { success: false };
    }
  };

  const handleCancelForm = () => {
    history.push(routes.home.root);
  };

  const handleSubmitForm = async (values, picture) => {
    const { pictureSizeError, success } = await handleCreateActivity(values, picture);
    if (pictureSizeError) return { pictureSizeError };
    if (success) history.push(routes.home.root);
  };

  const SideComponent = () => (
    <Grid container direction="column" style={{ height: 'auto' }}>
      <Grid container item justifyContent="center">
        <MaiaLogo />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '8vh' }}>
        <img src={sideImage} alt="Surf" width={200} />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '3vh' }}>
        <Typography className={classes.text} align="center" variant="h3">
          Mettez un nom explicite à votre activité.
        </Typography>
        <Typography className={classes.text} align="center" variant="h3" style={{ marginTop: '3vh' }}>
          Une belle photo est toujours une bonne idée pour attirer les clients.
        </Typography>
        <Typography className={classes.text} align="center" variant="h3" style={{ marginTop: '3vh' }}>
          Une description est primordiale pour que vos clients se projètent.
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction="column" style={{ height: 'auto' }}>
        <Grid className={classes.header} container item justifyContent="center" style={{ flexGrow: 0 }}>
          <Grid className={classes.title} container item xs={12} md={9} justifyContent="center">
            <Typography variant="h1">Votre première activité</Typography>
          </Grid>
        </Grid>

        <Grid container item justifyContent="center" style={{ flexGrow: 1 }}>
          <Grid item xs={12} md={10}>
            <ActivityForm
              activity={INITIAL_ACTIVITY}
              onCancel={handleCancelForm}
              onSubmit={handleSubmitForm}
              message="Si une prestation peut être réalisée par plusieurs moniteurs, pas d’inquiétude ! Vous pourrez la modifier plus tard !"
            />
          </Grid>
        </Grid>
      </Grid>
    </RegisterLayout>
  );
};

export default RegisterActivities;
